import BaseModule from './BaseModule.js';

class OtcOrder extends BaseModule {
  async paginate({
    page = 1,
    per_page = 20,
    term = null,
    status = null,
    customer_id = null,
    from = null,
    until = null,
  }) {
    const nz = (v) => (v === '' || v === undefined ? null : v);

    let f = nz(from);
    let u = nz(until);

    if (f && u && f > u) {
      const tmp = f;
      f = u;
      u = tmp;
    }

    const params = {
      page,
      per_page,
      ...(nz(term) && { term }),
      ...(nz(status) && { status }),
      ...(nz(customer_id) && { customer_id }),
      ...(f && { from: f }),
      ...(u && { until: u }),
    };

    return await this.get(`back-office/otc/orders`, { params });
  }

  async fetch(id) {
    return await this.get(`back-office/otc/orders/${id}`);
  }

  async statsOrder() {
    return await this.get(`back-office/otc/orders/stats`);
  }

  async acceptedOrder(id, transaction_id) {
    return await this.post(`back-office/otc/orders/${id}/accept`, {
      transaction_id: transaction_id,
    });
  }

  async cancelOrder(id, transaction_id) {
    return await this.post(`back-office/otc/orders/${id}/cancel`, {
      transaction_id: transaction_id,
    });
  }

  async dispatchCashouts(id, transaction_id, mode = 'BATCH') {
    return await this.post(`back-office/otc/orders/${id}/cashouts/dispatch`, {
      transaction_id,
      mode,
    });
  }

  async dispatchCashoutSingle(id, cashoutId, transaction_id, reset_attempts = true) {
    return await this.post(`back-office/otc/orders/${id}/cashouts/${cashoutId}/dispatch`, {
      transaction_id,
      reset_attempts,
    });
  }

  async retryFailedCashouts(id, transaction_id, reset_attempts = true) {
    return await this.post(`back-office/otc/orders/${id}/cashouts/failed/dispatch`, {
      transaction_id,
      reset_attempts,
    });
  }

  async completeCashoutsBatch(id, transaction_id) {
    return await this.post(`back-office/otc/orders/${id}/cashouts/complete`, {
      transaction_id,
    });
  }

  async cancelPaymentIntent(orderId, paymentId, intentId) {
    return await this.post(
      `back-office/otc/orders/${orderId}/payments/${paymentId}/intents/${intentId}/cancel`,
    );
  }

  async retryQuotePaymentIntents(intentUuid) {
    return await this.post(`back-office/quote-payment-intents/${intentUuid}/retry`);
  }

  async fetchCashoutMetrics(id, transaction_id) {
    return await this.get(`back-office/otc/orders/${id}/cashouts/metrics`, {
      params: { transaction_id },
    });
  }

  async download({
    status = null,
    customer_id = null,
    from = null,
    until = null,
    format = 'csv',
  } = {}) {
    const nz = (v) => (v === '' || v === undefined ? null : v);

    let f = nz(from);
    let u = nz(until);

    if (f && u && f > u) {
      const tmp = f;
      f = u;
      u = tmp;
    }

    const params = {
      ...(nz(status) && { status }),
      ...(nz(customer_id) && { customer_id }),
      ...(f && { from: f }),
      ...(u && { until: u }),
      ...(format && { format }),
    };

    const response = await this.axios.get('back-office/otc/orders/export', {
      params,
      responseType: 'blob',
    });

    const disposition = response.headers['content-disposition'] || '';
    let filename = this._extractFilenameFromDisposition(disposition);

    if (!filename) {
      const ts = new Date().toISOString().replace(/[:.]/g, '-');
      const ext = format === 'xlsx' ? 'xlsx' : format === 'pdf' ? 'pdf' : 'csv';
      filename = `otc-orders-${ts}.${ext}`;
    }

    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/octet-stream',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { ok: true, filename };
  }

  _extractFilenameFromDisposition(disposition) {
    if (!disposition) return null;

    let match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
    if (match && match[1]) {
      try {
        return decodeURIComponent(match[1].replace(/["']/g, ''));
      } catch (_) {
        //
      }
    }

    match = /filename="?([^";]+)"?/i.exec(disposition);
    if (match && match[1]) {
      return match[1].trim();
    }

    return null;
  }
}

export default OtcOrder;
